import dayjs from "dayjs"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template A7 - Number of policies effective, by four Underwriting/ Re-underwriting results, by age and sex of contractInsured Person"
	],
	["Age", "Sex", "Standard Plan", "", "", "", "Flexi Plan"],
	[
		"",
		"",
		"Standard Offer",
		"Offer with Premium Loading Only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Standard Offer",
		"Offer with Premium Loading Only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE"
	]
]

// Return calculated age
const getAge = item => {
	const dateOfBirth = item?.insureds?.[0]?.dateOfBirth
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	for (let i = 1; i < 100; i++) {
		output.push([
			i,
			"M",
			countEffectiveStandardOffer(i, "male", payload, "S00027"),
			countEffectiveOfferWithLoadings(i, "male", payload, "S00027"),
			countEffectiveOfferWithExclusions(i, "male", payload, "S00027"),
			countEffectiveOfferWithLoadingsAndExclusions(
				i,
				"male",
				payload,
				"S00027"
			),
			countEffectiveStandardOffer(i, "male", payload, "F00038"),
			countEffectiveOfferWithLoadings(i, "male", payload, "F00038"),
			countEffectiveOfferWithExclusions(i, "male", payload, "F00038"),
			countEffectiveOfferWithLoadingsAndExclusions(i, "male", payload, "F00038")
		])
	}
	for (let j = 1; j < 100; j++) {
		output.push([
			j,
			"F",
			countEffectiveStandardOffer(j, "female", payload, "S00027"),
			countEffectiveOfferWithLoadings(j, "female", payload, "S00027"),
			countEffectiveOfferWithExclusions(j, "female", payload, "S00027"),
			countEffectiveOfferWithLoadingsAndExclusions(
				j,
				"female",
				payload,
				"S00027"
			),
			countEffectiveStandardOffer(j, "female", payload, "F00038"),
			countEffectiveOfferWithLoadings(j, "female", payload, "F00038"),
			countEffectiveOfferWithExclusions(j, "female", payload, "F00038"),
			countEffectiveOfferWithLoadingsAndExclusions(
				j,
				"female",
				payload,
				"F00038"
			)
		])
	}
	return output
}

const countEffectiveStandardOffer = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			matchPlan &&
			dayjs().isAfter(policy?.startDate) &&
			dayjs().isBefore(policy?.endDate)
		) {
			return policy
		}
	}).length
}

const countEffectiveOfferWithLoadings = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings === true &&
			exclusions === false &&
			matchPlan &&
			dayjs().isAfter(policy?.startDate) &&
			dayjs().isBefore(policy?.endDate)
		) {
			return policy
		}
	}).length
}

const countEffectiveOfferWithExclusions = (age, gender, payload, plan) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			exclusions === true &&
			loadings === false &&
			matchPlan &&
			dayjs().isAfter(policy?.startDate) &&
			dayjs().isBefore(policy?.endDate)
		) {
			return policy
		}
	}).length
}

const countEffectiveOfferWithLoadingsAndExclusions = (
	age,
	gender,
	payload,
	plan
) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = policy?.contractInsured?.[0]?.gender
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings &&
			exclusions &&
			matchPlan &&
			dayjs().isAfter(policy?.startDate) &&
			dayjs().isBefore(policy?.endDate)
		) {
			return policy
		}
	}).length
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplateA7Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					product {
						productId {
							plan
						}
					}
					startDate
					endDate
					contractInsured {
						... on individual {
							gender
							dateOfBirth
						}
					}
					premium {
						loadings {
							id
						}
					}
					exclusions {
						id
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 1, c: 2 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 9 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
